<div class="modal-body feedback-form LVCLS-feedback-popup">
  <h4 class="LVCLS-pop-hdng">{{feedBackTitle}}</h4>
  <ng-container *ngFor="let item of feedbackQuestions; index as i">
    <ng-container *ngIf="i == 0">
      <p class="LVCLS-pop-subhdng">{{item.title}}</p>
      <div class="d-flex justify-content-start mb-3 feed-back flex-wrap">
        <ng-container *ngFor="let itemOpt of item.options">
          <button type="button" class="btn btn-outline-secondary LVCLS-btn-round-sm flex-fill-sm" [ngClass]="{'active': itemOpt.selected}" (click)="updateFormValue(i, itemOpt.key)">{{itemOpt.label}}</button>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="i == 1">
      <p class="LVCLS-pop-subhdng">{{item.title}}</p>
      <div class="d-flex justify-content-start flex-wrap mb-3 feed-back-2">
        <ng-container *ngFor="let itemOpt of item.options">
          <button type="button" class="btn btn-outline-secondary LVCLS-btn-round-sm" [ngClass]="{'active': itemOpt.selected}" (click)="updateFormValue(i, itemOpt.key)">{{itemOpt.label}}</button>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="i == 2 && isOpenFinalQuestion">
      <p class="LVCLS-pop-subhdng">{{item.title}}</p>
      <div class="mb-4">
        <div class="custom-control custom-checkbox custom-control-inline custom-control-sm-block mb-2" *ngFor="let itemOpt of item.options; index as k">
          <input type="checkbox" class="custom-control-input" id="customCheck{{k}}" [checked]="itemOpt.selected" (click)="updateFormValue(i, itemOpt.key)">
          <label class="custom-control-label" for="customCheck{{k}}">{{itemOpt.label}}</label>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <div
    class="d-flex justify-content-md-start justify-content-sm-center flex-sm-row flex-column border-top pt-4 align-self-center">
    <button class="btn btn-primary btn-blue mb-0" type="button" [disabled]="isSubmitDisabled" (click)="submitFeedbackForm()">Submit</button>
    <button type="button" class="btn-link mt-3 border-top-0 ml-md-3 skip-btn" (click)="skipFeedbackForm()" [disabled]="isSkipDisabled">SKIP</button>
  </div>
</div>